import React from "react";
const Section5Ready = () => (
  <>
    <h2>5. Ready to Elevate Your Social Media Performance?</h2>
    <p>You've seen what we stand for. You understand what makes Comparedly different.
    Now it’s time to take control of your social media strategy — with clarity, confidence, and competitive edge.
    </p>
    <p>Whether you're a growing brand, a fast-moving marketing team, or a solo content creator, <strong>Comparedly is built to amplify your digital success.</strong></p>

  </>
  
);

export default Section5Ready;
